/**
 * Created by carlhaynes on 9/28/17.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CollectorItem from "./CollectorItem";

class CollectorList extends Component {

  constructor(props) {
    super(props);
    console.log(props);
  }

  // componentWillMount() {
  //   console.log("CollectorList componentWillMount");
  //   console.log("length: " + this.props.collectors.length);
  // }

  render() {
    console.log("render CollectorList");
    console.log("length: " + this.props.collectors.length);
    return (
      <div>
        hello {this.props.collectors.length}
        <p/>
        {this.props.collectors.map(function(collectorValue){
          console.log("map");
          console.log(collectorValue);
          return <CollectorItem key={collectorValue.uid} collector={collectorValue}/>
        })}
      </div>
    );
  }
}

CollectorList.propTypes = {
  collectors: PropTypes.array.isRequired
};

export default CollectorList;



// WEBPACK FOOTER //
// ./src/Components/CollectorList.jsx